export const v_tool_category = "tool_category/all-category"
export const v_tool_subcategory = "tool_subcategory/all-subcategory"
export const v_product = "product/get-product"
export const quotation = "quotation"
export const common_attributes="common-attributes"
export const v_get_products="product"
export const v_get_manufactured_products="manufacture_products"
export const v_tooltype = "tool_type"
export const tool_category="tool_category"
export const tool_subcategory="tool_subcategory"
export const v_uom = "/uom"
export const v_cart = "/cart"
export const v_top_common_attributes=[{sequence:1,attribute_name:"Standard"},{sequence:2,attribute_name:"Tool Material"},{sequence:3,attribute_name:"Coating",},{sequence:4,attribute_name:"Regrindable"},{sequence:5,attribute_name:"Weldon Flat"}]
export const v_bottom_common_attributes=[{sequence:1,attribute_name:"Workpiece Material"},{sequence:2,attribute_name:"Hardness"},{sequence:3,attribute_name:"Application Details",}]

